import React from 'react';
import { useSelector } from 'react-redux';
import framework from 'utils/framework';
import { Box, Flex, Text } from 'components/ui';
import ShareButton from 'components/CreatorStoreFront/ShareButton/ShareButton';
import { textResourcesSelector } from 'selectors/creatorStoreFront/textResourcesSelector';
import anaConsts from 'analytics/constants';

const { wrapFunctionalComponent } = framework;

const CollectionDetailsHeader = ({ collectionTitle, collectionDescription, totalProducts }) => {
    const textResources = useSelector(textResourcesSelector);

    return (
        <Flex
            width='100%'
            justifyContent={'space-between'}
            alignItems='flex-start'
            gap={[4, null, '60px']}
        >
            {/* Collection Info Section */}
            <Flex
                width='100%'
                flexDirection='column'
                alignItems='flex-start'
                gap={1}
            >
                <Text
                    fontSize='md'
                    fontWeight='bold'
                    lineHeight={['20px', null, '22px']}
                    fontFamily='Helvetica Neue'
                    children={collectionTitle}
                />
                {collectionDescription && (
                    <Text
                        fontSize={['sm', null, 'base']}
                        lineHeight={['14px', null, '18px']}
                        fontFamily='Helvetica Neue'
                        alignSelf='stretch'
                        children={collectionDescription}
                    />
                )}
                <Text
                    fontSize='sm'
                    color={'gray'}
                    lineHeight='14px'
                    fontFamily='Helvetica Neue'
                    children={`${totalProducts} ${textResources.items}`}
                />
            </Flex>

            {/* Share Button */}
            <Box flexShrink={0}>
                <ShareButton
                    pathName={anaConsts.PAGE_TYPES.COLLECTION_DETAIL}
                    textResources={textResources}
                />
            </Box>
        </Flex>
    );
};

export default wrapFunctionalComponent(CollectionDetailsHeader, 'CollectionDetailsHeader');
